<template>
    <div>
        <Modal v-model="modal" :mask-closable="false" :closable="false" :width="width" >
            <p slot="header" style="color:#488bea;">
                <Icon type="ios-information-circle"></Icon>
                <span>微信卡券</span>
            </p>
            <Section>

                <FilterBox :item-right="10" inline style="padding: 20px 0px 10px 22px;">
                    <FilterBoxItem>
                        <Input style="width: 260px" :maxlength="50" placeholder=' 卡券card_id' v-model="searchText" />
                        <span style="margin-left: 10px;line-height: 34px;">{{searchText.trim().length}}/50</span>
                    </FilterBoxItem>
                    <FilterBoxItem>
                        <Button type="primary" @click="search">查找</Button>
                    </FilterBoxItem>
                    <FilterBoxItem label="清除">
                        <Icon style="line-height: 33px" color="#999" size="15" @click="clear" type="ios-close-circle"  />
                    </FilterBoxItem>
                </FilterBox>

                <!--<LabelHeader border>
                    <div slot="before">
                        <span class="fs-12px colorA3 mr-10px">全选(已选 <font color="#307deb">{{selectCell.length}}</font> )个</span>
                    </div>
                    &lt;!&ndash;<div slot="after">
                        <span class="fs-12px colorA3 mr-10px"><font color="red">{{tableData.length}}</font>/10</span>
                    </div>&ndash;&gt;
                </LabelHeader>-->
            </Section>
            <div style="text-align:center">
                <Table border :columns="columns" highlight-row :loading="loading" :data="tableData"></Table>
                <!--<Page :total="total"  ref="pages" :page-size="pageSize"  @on-change="pageOnChange" style="text-align: right; margin-top: 20px"></Page>-->
            </div>
            <div slot="footer">
                <Button  size="large" @click="onCancel">关闭</Button>
                <Button  type="primary" size="large" @click="submit">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'
    import FilterBox from '@/modules/FilterBox';
    import FilterBoxItem from '@/modules/FilterBoxItem';
    import IForm from "iview/src/components/form/form";
    import JQ from 'jquery';

    import { Table, Page, Button, Input, Modal , Icon} from 'iview';

    export default {
        name: "WeChatCard",
        props: {
            modal: {
                default: false
            },
            width:{
                default: 800
            },
            onCancel:{
                type: Function,
                default: () => {}
            }
        },
        components: {
            LabelHeader,
            FilterBox,
            FilterBoxItem,
            Table,
            Button,
            Page,
            Modal,
            Input,
            Icon,
        },
        data () {
            return {
                columns: [
                    /*{
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },*/
                    {
                        title: '卡券类型',
                        key: 'cardType',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            let text = "";
                            switch(params.row.cardType) {
                                case "DISCOUNT":
                                    text = "折扣券";
                                    break;
                                case "GIFT":
                                    text = "礼品券";
                                    break;
                                case "GROUPON":
                                    text = "团购券";
                                    break;
                                case "CASH":
                                    text = "代金券";
                                    break;
                                case "GENERAL_COUPON":
                                    text = "通用券";
                                    break;
                                default:
                                    text = "其他券";
                            }
                            return h('span', {style:{color:"#FF3300"}}, text)
                        }
                    },
                    {
                        title: '现库存量',
                        key: 'quantity',
                        align: 'center',
                        maxWidth: 120
                    },
                    {
                        title: '标题',
                        key: 'title',
                        align: 'center',
                        minWidth: 140
                    },
                    {
                        title: '商户名',
                        key: 'brandName',
                        align: 'center',
                        minWidth: 160
                    },
                    {
                        title: '卡券状态',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            let text = "";
                            switch(params.row.status) {
                                case "CARD_STATUS_NOT_VERIFY":
                                    text = "待审核";
                                    break;
                                case "CARD_STATUS_VERIFY_FAIL":
                                    text = "审核失败";
                                    break;
                                case "CARD_STATUS_VERIFY_OK":
                                    text = "通过审核";
                                    break;
                                case "CARD_STATUS_DELETE":
                                    text = "卡券被商户删除";
                                    break;
                                case "CARD_STATUS_DISPATCH":
                                    text = "在公众平台投放过的卡券";
                                    break;
                                default:
                                    text = "其他";
                            }
                            return h('span', {style:{color:"#FF3300"}}, text)
                        }
                    },

                    {
                        title: '操作',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            /*let that = this;
                            let btnStyle = "padding:0 10px;";
                            var buttons = [];
                            buttons.push(h('a', {style: btnStyle, on: {
                                    click: () => {
                                        this.formValidate.title = params.row.title;
                                        this.formValidate.id = params.row.id;
                                        this.loading = false;
                                        this.EditorModal = true;
                                    }
                                }}, '编辑标题'));
                            return h('div',buttons);*/
                        }
                    }
                ],


                formValidate: {
                    title:'',
                    lotteryNumber:0, //抽奖次数
                },
                ruleValidate: {
                    lotteryNumber:[
                        {required:true, type:"Number", message:'请输入抽奖次数',trigger: 'blur'}
                    ],
                    title: [
                        {required:true, message: '标题不能为空', trigger: 'blur' }
                    ]
                },

                tableData: [],  //列表展示数据
                resultdata:[],  //请求返回总数数据
                selectCell:[],

                loading:false, //加载状态

                //检索条件
                searchForbidden:"all",
                searchText:"",//查询条件文本

                pageSize: 10, //每页展示数量
                NumberModal:false,//抽奖次数
                ProbabilityModal:false,//中奖概率
                EditorModal:false,//编辑
                total:0,

                floorNames:[],//楼层名称数组
                pois:[],//根据名称查询到的poi数组
                poiNames:[],//poi数组拼接的字符串
                isFindPoi:true,
                ID:null,//当前操作行的ID

                delModal:false,//删除框
                upModal:false,//升锁编辑框
                downModal:false,
                forbiddenModal:false,
                validModal:false,
                parkingLock:null,//当前编辑的车位锁
                lockNumber:null,
                poiName:null,
                floorSelect:"-1",//v-modal 双向绑定后设置初始默认选中

                poiSelect:-1,
                upLength:0,//已升锁数据条数
                downLength:0,//已降锁数据条数
                selectedArr:[],//选中的数据
            }

        },
        methods: {
            //查询所有记录
            request(page) {
                if (this.loading) return;
                this.loading = true;
                let obj = this.getOffsetCount(page);
                this.$request.get(`${this.$HOST}/back/luckyDraw/synchronousCard?offset=${obj.offset}&count=${obj.count}`,).then((res)=>{
                    this.loading = false;
                    if (!res.data.code && res.data.result) {
                        console.log(res.data.result);
                        this.tableData = res.data.result;
                        this.formValidate.tableData = res.data.result;
                    }
                });
            },

            getOffsetCount (page){
                if (!page) page = 1;
                return {offset:(page-1)*this.pageSize,count:this.pageSize};
            },

            onSelectionChange (cell){
                this.selectCell = cell;
                console.log("this.selectCell",this.selectCell);
            },

            pageOnChange (page){
                this.request(page);
            },


            /**
             * 检索事件
             */
            search (){
                if (this.loading) return;
                this.loading = true;
                this.tableData = [];
                this.$request.get(`${this.$HOST}/back/luckyDraw/queryWeChatCard?cardId=${this.searchText.trim()}`).then((res)=>{
                    this.loading = false;
                    if (!res.data.code && res.data.result) {
                        this.tableData.push(res.data.result);
                    }else this.$Message.error(res.data.message);
                });
            },

            submit (){
                if (this.tableData.length){
                    if (this.loading) return;
                    this.loading = true;
                    this.$request.post(`${this.$HOST}/back/cardActivity/save`,this.tableData[0]).then((res)=>{
                        this.loading = false;
                        if (!res.data.code && res.data.result) {
                            this.$parent.$parent.weChatCardOnCancel();
                        }else  this.$Message.error(res.data.message);
                    });
                } else this.$parent.$parent.WeChatCardModal = false;
            },

            clear (){
                this.tableData = [];
                this.searchText = "";
                this.selectCell = [];
            }
        },

        /**
         * 监听
         */
        watch:{
            modal (modal) {
                if (modal){
                    this.tableData = [];
                    this.searchText = "";
                    this.selectCell = [];
                }
            }
        },

        created(){
            //this.request(1);
        },

        mounted () {


        },
    }
</script>

<style scoped>
</style>
